import { message } from "ant-design-vue";
import { MessageArgsProps,ConfigOnClose, ConfigOptions, MessageType } from "ant-design-vue/lib/message";

/**
 * 消息服务
 */
export default class MessageService {
    public static info(content: any, duration?: any, onClose?: ConfigOnClose): MessageType {
        return message.info(content, duration, onClose);
    }

    public static success(content: any, duration?: any, onClose?: ConfigOnClose): MessageType {
        return message.success(content, duration, onClose);
    }

    public static error(content: any, duration?: any, onClose?: ConfigOnClose): MessageType {
        return message.error(content, duration, onClose);
    }

    public static warn(content: any, duration?: any, onClose?: ConfigOnClose): MessageType {
        return message.warn(content, duration, onClose);
    }

    public static warning(content: any, duration?: any, onClose?: ConfigOnClose): MessageType {
        return message.warning(content, duration, onClose);
    }

    public static loading(content: any, duration?: any, onClose?: ConfigOnClose): MessageType {
        return message.warning(content, duration, onClose);
    }

    public static open(args: MessageArgsProps): MessageType {
        return message.open(args);
    }

    public static config(options: ConfigOptions): void {
        message.config(options);
    }

    public static destroy(): void {
        message.destroy();
    }
}
